import btnClose from '@/components/btnClose/btnClose.vue'
import Switcher from '@/components/Switcher/Switcher.vue'
import CustomCheckBox from '@/components/CustomCheckBox/CustomCheckBox.vue'
import CustomInput from '@/components/CustomInput/CustomInput.vue'
import CustomDropdown from '@/components/CustomDropdown/CustomDropdown.vue'
import CustomDropdownBorder from '@/components/CustomDropdownBorder/CustomDropdownBorder.vue'
import CustomTooltipLeft from '@/components/CustomTooltipLeft/CustomTooltipLeft.vue'
import CustomTrComponent from '@/components/CustomTrComponent/CustomTrComponent.vue'
import EmptyMessage from '@/components/EmptyMessage/EmptyMessage.vue'
import confirmModal from '@/components/modals/confirmModal/confirmModal.vue'
import Preloader from "@/components/Preloader/Preloader.vue";
import ActionModal from "../modals/actionModal/ActionModal.vue";
import DoneBlock from "@/components/modals/actionModal/DoneBlock.vue";
import TableMobileShared from "@/components/TableMobileShared/TableMobileShared";
import {mapGetters} from "vuex"
import Pagination from "@/components/__new_ui_kit/Pagination/Pagination";
import DeleteGateModal from "@/components/__new_ui_kit/Modals/DeleteGateModal/DeleteGateModal";
import {defaultComponentProps, defaultModalEvents, defaultModalProps} from "@/components/__new_ui_kit/Modal/defaults";

export default {
    name: 'TableShared',
    components: {
        btnClose,
        Switcher,
        CustomCheckBox,
        CustomDropdown,
        CustomDropdownBorder,
        CustomInput,
        CustomTooltipLeft,
        CustomTrComponent,
        EmptyMessage,
        confirmModal,
        Preloader, ActionModal, DoneBlock,
        TableMobileShared,
        Pagination
    },
    data() {
        return {
            visitsUp: false,
            downloadsUp: false,
            createdUp: false,
            emailsUp: false,
            selectedOption: null,
            arrayOfObjects: [
                {id: 1, name: 'Last created'},
                {id: 2, name: 'Most popular'},
                {id: 3, name: '2 months'},
                {id: 4, name: '6 months'}
            ],
            listBubble: [
                {name: 'Account', src: '/account'},
                {name: 'Log out', src: '/logout'},
            ],
            flag: '',
            email: '',
            text: '',
            password: '',
            visibleB: true,
            tooltipDropdown: [
                {option: 'Profile settings', href: "/profile-settings"},
                {option: 'Logout', href: "/logout"},
            ],
            list: [],
            maxElementOnPage: 15,
            page: 1,
            sort: '',
            filter: 1,
            sort_type: '',
            previewPage: 1,
            totalElements: 1,
            paginateClick: false,
            showPreloader: true,
            success_delete: false,
            sortBy: [
                { id: 1, name: 'Created At' },
                { id: 2, name: 'Visits' },
                { id: 3, name: 'Downloads' }
            ],
            selectedSortedOption: { id: 0, name: 'Sort by' },
        }
    },
    methods: {
        async changePage(page) {
            this.page = page
            await this.contentList()
        },
        sortByDate() {
            let sortType = 'desc';
            if (this.createdUp) {
                sortType = 'asc';
            }
            this.sortByHelper('created_at', '', sortType);
            this.createdUp = !this.createdUp
        },
        deleting() {
            this.$store.dispatch('deleteStatus').then()
        },
        updatePageNum (arg) {
            this.page = arg
            this.success_delete = true
        },
        methodToRunOnSelect(payload) {
            this.selectedOption = payload;
            this.sort = '';
            this.page = 1;
            this.filter = payload.id
            this.contentList();
        },
        sortByVisits(payload) {
            let sortType = 'desc';
            if (this.visitsUp) {
                sortType = 'asc';
            }
            this.sortByHelper('visits', '', sortType);
            this.visitsUp = !this.visitsUp
            this.downloadsUp = false
            this.emailsUp = false

        },
        sortByDownloads() {
            let sortType = 'desc';
            if (this.downloadsUp) {
                sortType = 'asc';
            }
            this.sortByHelper('downloads', '', sortType);
            this.downloadsUp = !this.downloadsUp
            this.visitsUp = false
            this.emailsUp = false

        },
        sortByHelper(sort, filter, sortType) {
            this.sort = sort;
            this.filter = filter;
            this.sort_type = sortType;
            this.contentList();
        },
        sortByEmails() {
            let sortType = 'desc';
            if (this.emailsUp) {
                sortType = 'asc';
            }
            this.sortByHelper('emails', '', sortType)
            this.emailsUp = !this.emailsUp
            this.visitsUp = false
            this.downloadsUp = false

        },
        async contentList() {
            return await this.$store.dispatch('contentList', {
                page: this.page,
                sort: this.sort,
                type: this.sort_type,
                filter: this.filter,
            }).then(resp => {
                this.list = resp.data.data
                this.page = resp.data['current_page']
                this.previewPage = this.page

                this.totalElements = resp.data.total;

                // localStorage.list = JSON.stringify(this.list);

                localStorage.list = JSON.stringify(this.list);

                (setTimeout(() => this.showPreloader = false, 500))
                this.paginateClick = false

                // this.eventsTooltip()

                return this.list
            })
        },
        async updateList() {
            let validPage = this.$store.getters.getFlexiblePage
            await this.changePage(validPage)
        },
        paginateDec(event) {
            this.paginateClick = true;
            if (this.page > 1) {
                this.page--;
                this.contentList();
            }
        },
        paginateInc(event) {
            this.paginateClick = true;
            if (this.page < this.totalElements) {
                this.page++;
                this.contentList();
            }
        },
        transitionPage(page, currentPage) {
            this.paginateClick = true;
            this.page = page;
            if (page !== currentPage) {
                this.contentList();
            }
        },
        changeActive(data) {
            this.$store.dispatch('changeContentActive', {
                    id: data.id,
                    active: data.status
                }
            )
        },
        link(uri) {
            return process.env.VUE_APP_URL + `/${uri}`;
        },
        updateContent(id, propTabAnalytics) {
            //this.$router.push({ path:`/my-gates/${id}`})
            //*****
            let name = 'Analytics Page';
            if (propTabAnalytics !== 'true') {
                name = 'Settings Page';
            }
            this.$router.push({
                name: name,
                params: {
                    id: `${id}`,
                    propTabAnalytics: `${propTabAnalytics}`
                }
            })
        },
        /* for mobile table */
        openDeleteModal(deleteId) {
            this.$modal.show(DeleteGateModal,
              {...defaultComponentProps, 'deleteId': deleteId, 'updateList': this.updateList},
              {...defaultModalProps(), name: 'delete-gate-modal'},
              {...defaultModalEvents(() => console.log('check cancel cb'))})
        },
        closeConfModal() {

        },
        changeSort(payload) {
            if (payload.name && payload.id) {
                let sortType = 'desc';
                let sort = false;
                this.sortBy.forEach(item => {
                    if (item.name === payload.name) {
                        sort = payload.name.replace(' ', '_').toLowerCase();
                    }
                });
                if (sort) {
                    this.sortByHelper(sort, '', sortType);
                }
            }
        },
        eventsTooltip() {
            document.getElementsByClassName('tooltip-block').forEach(item => {
                item.onmouseenter = event => {this.tooltipToggleHandler(event, true)};
                item.onmouseleave = event => {this.tooltipToggleHandler(event, false)};
            });
        },
        tooltipToggleHandler(event, show = true) {
            let currentNode = event.currentTarget;
            let parent = currentNode.closest('.tooltip-block');
            let tooltip = parent.getElementsByClassName('tooltip');
            if (show) {
                tooltip[0].style.display = 'block';
            } else {
                tooltip[0].style.display = 'none';
            }
            tooltip[0].innerText = tooltip[0].dataset.content;
        }
    },
    // created() {
    //     this.contentList()
    // },
    mounted() {
        this.contentList()
    },
    computed: {
        ...mapGetters(['toogleConfirm', 'getContents', 'getPaginationPage', 'getPaginationTotalElements', 'getLastPage', 'getDeleteStatus']),
    }

}
